export default __webpack_public_path__ + "static/media/init-state.8d51c212.svg";